/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiIncrementalityFinancialSummaryFromJSON(json) {
    return ApiIncrementalityFinancialSummaryFromJSONTyped(json, false);
}
export function ApiIncrementalityFinancialSummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'estimatedRevenueImpactPercentage': !exists(json, 'estimatedRevenueImpactPercentage') ? undefined : json['estimatedRevenueImpactPercentage'],
        'estimatedRevenueImpactValue': !exists(json, 'estimatedRevenueImpactValue') ? undefined : json['estimatedRevenueImpactValue'],
        'netIncrementalImpactPercentage': !exists(json, 'netIncrementalImpactPercentage') ? undefined : json['netIncrementalImpactPercentage'],
        'netIncrementalImpactValue': !exists(json, 'netIncrementalImpactValue') ? undefined : json['netIncrementalImpactValue'],
        'reducedAdSpendPercentage': !exists(json, 'reducedAdSpendPercentage') ? undefined : json['reducedAdSpendPercentage'],
        'reducedAdSpendValue': !exists(json, 'reducedAdSpendValue') ? undefined : json['reducedAdSpendValue'],
        'roiOfChange': !exists(json, 'roiOfChange') ? undefined : json['roiOfChange'],
    };
}
export function ApiIncrementalityFinancialSummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'estimatedRevenueImpactPercentage': value.estimatedRevenueImpactPercentage,
        'estimatedRevenueImpactValue': value.estimatedRevenueImpactValue,
        'netIncrementalImpactPercentage': value.netIncrementalImpactPercentage,
        'netIncrementalImpactValue': value.netIncrementalImpactValue,
        'reducedAdSpendPercentage': value.reducedAdSpendPercentage,
        'reducedAdSpendValue': value.reducedAdSpendValue,
        'roiOfChange': value.roiOfChange,
    };
}
